import { Component } from "@angular/core";
import { ToastService } from "../../../core/services/toast.service";

@Component({
  selector: "app-toast",
  standalone: true,
  template: `
    @if (toastService.toasts().length) {
      <div class="pointer-events-none fixed bottom-4 right-4 z-50 flex flex-col gap-2">
        @for (toast of toastService.toasts(); track toast.id) {
          <div
            class="pointer-events-auto flex max-w-sm items-center gap-2 rounded-lg border px-4 py-3 shadow-lg animate-slide-in"
            [class.border-green-200.bg-green-50]="toast.type === 'success'"
            [class.border-red-200.bg-red-50]="toast.type === 'error'"
            (click)="toastService.remove(toast.id)"
          >
            @if (toast.type === "success") {
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            } @else {
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            }
            <p
              class="text-sm font-medium"
              [class.text-green-800]="toast.type === 'success'"
              [class.text-red-800]="toast.type === 'error'"
            >{{ toast.message }}</p>
            <button class="ml-auto flex-shrink-0 text-slate-400 hover:text-slate-600">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
          </div>
        }
      </div>
    }
  `,
  styles: `
    :host {
      display: contents;
    }
    @keyframes slide-in {
      from {
        opacity: 0;
        transform: translateX(100%);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
    .animate-slide-in {
      animation: slide-in 0.3s ease-out;
    }
  `
})
export class ToastComponent {
  constructor(readonly toastService: ToastService) {}
}
